<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createCompany.contactInformationForm.title'|translate}}</h3>
      <h5> {{'createCompany.contactInformationForm.subtitle'|translate}}</h5>
    </div>

    <app-input-field [control]="formGroup.controls.telephoneNumber"
                     class="field-container"
                     [label]="'createCompany.contactInformationForm.telephoneNumber'|translate">
      <input name="telephoneNumber"
             formControlName="telephoneNumber"
             class="input">
    </app-input-field>
    <app-input-field [control]="formGroup.controls.faxNumber"
                     class="field-container"
                     [label]="'createCompany.contactInformationForm.faxNumber'|translate">
      <input name="faxNumber"
             formControlName="faxNumber"
             class="input">
    </app-input-field>
    <app-input-field [control]="formGroup.controls.emailAddress"
                     class="field-container"
                     [label]="'createCompany.contactInformationForm.email'|translate">
      <input name="emailAddress"
             formControlName="emailAddress"
             class="input">
    </app-input-field>
    <app-input-field [control]="formGroup.controls.seatNumber"
                     class="field-container"
                     [label]="'createCompany.contactInformationForm.seatNumber'|translate">
      <input name="seatNumber"
             formControlName="seatNumber"
             class="input">
    </app-input-field>

  </div>
</form>
